module.exports = __webpack_public_path__ + "img/flag-swallowtail.208dc1a4.svg";